import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "@tanstack/react-router";
import { authClient } from "@/lib/auth.ts";

export function useSignOut() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  /** `redirect`: where to land after signing in again. */
  return async function signOut(redirect?: string) {
    await authClient.signOut();
    queryClient.clear();
    await navigate({ to: "/sign-in", search: redirect ? { redirect } : {} });
  };
}
